import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './VerificationCodePage.less';

export default class VerificationCodePage extends OfficialPage {
  state = {
    codeImgUrl: '',
    codeNum: '',
    codeStatus: 0
  }

  constructor(props) {
    super(props);
    document.title = '核销码';
  }

  componentWillMount(option = getCurrentPageQueryParams()) {
    let that = this
    let subShopAppId = option.sub_shop_app_id
    let orderId = option.detail
    app.sendRequest({
      url: '/index.php?r=AppShop/GetOrderVerifyCode',
      data: {
        sub_shop_app_id: subShopAppId,
        order_id: orderId
      },
      success: that.setVerificationCodeData
    })
  }

  setVerificationCodeData = res => {
    let that = this
    that.setData({
      codeImgUrl: res.data.qrcode_url,
      codeNum: res.data.code,
      codeStatus: res.data.status
    })
    // TODO that.connectSocket()
  }
  timeInterval = ''
  connectSocket = () => {
    var that = this
    app.connectSocket({
      url: 'wss://test.zhichiwangluo.com',
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function (res) {
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_order_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.timeInterval = setInterval(function () {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function (res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_order_verify' && msg.status == 0) {
          that.setData({
            codeStatus: 1
          })
          clearInterval(that.timeInterval)
          app.closeSocket()
        }
      }
    })
  }

  componentWillUnmount() {
    var that = this
    clearInterval(that.timeInterval)
    // TODO app.closeSocket()
  }

  render() {
    const { showGetUserInfo, codeStatus, codeImgUrl, codeNum } = this.state
    return (
      <div className="official-page verification-code-page">
        <TopNav title="核销码"/>
        <div className="page" id="verificationCodePage">
          <div
            className={
              'verification-code-area ' + (codeStatus == 1 ? 'finished' : '')
            }
          >
            <img className="verification-code-img" src={codeImgUrl} />
            <div className="verification-code-text">
              <div>核销码:</div>
              <div className="num">{codeNum}</div>
            </div>
            <div className="verification-code-finished">
              <div className="text">已完成</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/verification-code-page/VerificationCodePage.jsx